import { MANAGER_STEP3_MISSING_PDF_TEXT } from '../../manager/step3/constants.ts';

export const CLIENT_APPROVAL_LETTER_SIGN_TEXT = {
  sectionStep: '03',
  sectionTitle: 'Лист-погодження',
  sectionDescription: 'Перегляньте лист-погодження перед підписанням.',
  previewTitle: 'Лист-погодження',
  openButton: 'Відкрити PDF в новій вкладці',
  signButton: 'Підписати',
  signSuccessMessage: 'Лист-погодження успішно підписано.',
  missingFileMessage: MANAGER_STEP3_MISSING_PDF_TEXT,
} as const;
